import axios from 'axios'
import * as urls from '@/constants/url'
export default {
  async uploadImages (data) {
    return await axios.post(urls.EDITOR_IMG_UPLOAD_URL, data)
  },
  // not used
  async getImages () {
    return await axios.get(urls.EDITOR_IMG_BROWSE_URL)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

}
